<template>
  <div>
    <ul @click.stop="stopHandle"
      :class="`nav nav-aside nav_name_${n.name}`"
      v-for="(n, i) in $store.state.app.routes.filter(
        x =>
          x.meta != undefined &&
          !x.meta.hideInMenu &&
          (x.meta.access == undefined ||
            x.meta.access.length == 0 ||
            hasOneOf(x.meta.access, $store.state.user.access))
      )"
      :key="i"
    >
      <li class="nav-label text-break text-wrap">{{ n.meta.title }}</li>
      <li
        v-for="(s, si) in n.children.filter(
          x =>
            !x.meta.hideInMenu &&
            (x.meta.access.length == 0 ||
              hasOneOf(x.meta.access, $store.state.user.access))
        )"
        :key="si"
        :class="`nav-item ${$route.name == s.name ? 'active' : ''}`"
      >
        <!-- <a role="button" class="nav-link" @click="turnToPage({name: s.name, params: s.params })">
                <feather :type="s.meta.icon" :size="16"></feather> <span>{{s.meta.title}} {{s.params}}</span>
            </a> -->
        <div @click="cstmMnuClicked(s.name)" v-if="hasCustomClick(s.name)" role="button" class="nav-link">
          <feather :type="s.meta.icon" :size="16"></feather>
          <span class="text-break text-wrap lh-3">{{ s.meta.title }}</span>

          <div v-if="s.name=='msnger'" class="badge badge-primary mg-l-auto" v-show="$store.state.signalr.team.notSeenConversationCount>0">
            {{$store.state.signalr.team.notSeenConversationCount}}
          </div>
        </div>
        <router-link v-else
          role="button"
          class="nav-link"
          :to="{ name: s.name, params: s.params }"
        >
          <feather :type="s.meta.icon" :size="16"></feather>
          <span class="text-break text-wrap lh-3">{{ s.meta.title }}</span>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { hasOneOf } from "@/libs/tools";
import { mapActions } from "vuex";

export default {
  mounted() {
    // let self= this;
    // console.log('mmmmmmmmmmmmmmmmmm', this.$store.state.app.routes.filter(x=>x.path=='/lms' &&
    // x.meta!=undefined &&
    // x.meta.hideInMenu  &&
    // (x.meta.access==undefined || x.meta.access.length==0 || hasOneOf(self.$store.state.user.access, x.meta.access))
    // )
    // [0].children.filter(
    //   x=>!x.meta.hideInMenu
    //   && (
    //     x.meta.access.length==0
    //     ||
    //     self.hasOneOf(self.$store.state.user.access, x.meta.access)
    //   )
    // )
    // );
  },
  data(){
    return{
      customMenus: [
        'msnger'
      ],
    }
  },
  methods: {
    ...mapActions([ "handleMessenger", ]),
    stopHandle(){
      //if (screen.width <= 1024) {
          window.$("body").removeClass("show-aside");
        //}
    },
    turnToPage(route) {
      let { name, params, query } = {};
      if (typeof route === "string") name = route;
      else {
        name = route.name;
        params = route.params;
        query = route.query;
      }

      if (this.$route.name != route.name)
        this.$router.push({ name, params, query });
    },
    hasOneOf(t, v) {
      return hasOneOf(t, v);
    },
    hasCustomClick(name){
      return hasOneOf(this.customMenus, [name]);
    },
    cstmMnuClicked(name){
      switch(name){
        case 'msnger':
          let obj= this.$store.state.app.messenger;
          obj.open= true;
          this.handleMessenger(obj);
          break;
        default: break;
      }
    }
  }
};
</script>

<style></style>
